/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_No_Passkeys_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add a passkey to enable passwordless authentication for your account." |
*
* @param {Profile_Security_No_Passkeys_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_no_passkeys_description = /** @type {((inputs?: Profile_Security_No_Passkeys_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_No_Passkeys_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie einen Passkey hinzu, um die passwortlose Authentifizierung für Ihr Konto zu aktivieren.")
	return /** @type {LocalizedString} */ ("Add a passkey to enable passwordless authentication for your account.")
});